import { render, staticRenderFns } from "./documentRequestTab.vue?vue&type=template&id=54140eea&scoped=true&"
import script from "./documentRequestTab.vue?vue&type=script&lang=js&"
export * from "./documentRequestTab.vue?vue&type=script&lang=js&"
import style0 from "./documentRequestTab.vue?vue&type=style&index=0&id=54140eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54140eea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabs,VTabsSlider})
